import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import Image from 'next/image';
import styles from './MidTermFeatureBanner.module.scss';
interface FeatureItem {
  icon: string;
  title: string;
}
interface MidTermFeatureBannerProps {
  features: FeatureItem[];
}
const MidTermFeatureBanner: React.FC<MidTermFeatureBannerProps> = ({
  features
}) => {
  return <Box className={styles['midterm-feature-banner-container']} data-sentry-element="Box" data-sentry-component="MidTermFeatureBanner" data-sentry-source-file="MidTermFeatureBanner.tsx">
      {features.map((feature, index) => <Box key={'MID_TERM_FEATURES_' + index} className={styles['feature-item']}>
          <Image src={feature.icon} alt={feature.title} width={24} height={24} />
          <Typography variant="bodyS" className={styles['feature-title']}>
            {feature.title}
          </Typography>
        </Box>)}
    </Box>;
};
export default MidTermFeatureBanner;